import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { sdk } from "./sdk"

export const FIELD_TYPES = { text: "Single line text", multiline: "Multi-line text", integer: "Integer", decimal: "Decimal", boolean: "True or false", url: "URL", date: "Date", color: "Color" } as const
export type FieldType = keyof typeof FIELD_TYPES
export type Definition = { id: string; owner: "product"; name: string; key: string; type: FieldType; description: string }

const KEY = ["settings", "custom-data"]
export const useCustomData = () => useQuery({ queryKey: KEY, queryFn: () => sdk.client.fetch<{ definitions: Definition[] }>("/admin/terify/settings/custom-data") })
export function useSaveCustomData() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (definitions: Definition[]) => sdk.client.fetch<{ definitions: Definition[] }>("/admin/terify/settings/custom-data", { method: "POST", body: { definitions } }),
    onSuccess: (r) => qc.setQueryData(KEY, r),
  })
}
/** Where a value is stored in product.metadata. */
export const metaKey = (key: string) => `custom.${key}`
